<app-decarbonization-type-list
    [regions]="regions"
    [types]="selfFuelTypes"
    [removableTypesId]="removableFuelTypesId"
    [canCreateDecarbonizationTypes]="canCreateDecarbonizationTypes"
    [canManageRegionDecarbonizationTypes]="canManageRegionDecarbonizationTypes"
    [typeCreationButtonKey]="'decarbonization.fuel-types.creation-modal.add-button'"
    [typeAddRegionButtonKey]="'decarbonization.fuel-types.region-add.add-button'"
    [titleKey]="'decarbonization.fuel-types.title'"
    [searchTitleKey]="'decarbonization.fuel-types.search-title'"
    [searchPlaceholderKey]="'decarbonization.fuel-types.search-placeholder'"
    (openTypeCreationModal)="openFuelTypeCreationModal()"
    (openRegionTypeAddModal)="openRegionFuelTypeAddModal()"
    (deleteItem)="openFuelTypeDeletionModal($event)"
    (removeRegionItem)="openFuelTypeRegionRemovalModal($event)"
></app-decarbonization-type-list>

<ng-template #fuelTypeCreationModal>
    <div>
        <h3 [i18n]="'decarbonization.fuel-types.creation-modal.description'"></h3>
        <input type="text"
               class="form-control"
               [(ngModel)]="newFuelType"
               [i18n]="[{target: 'attribute:placeholder', key: 'decarbonization.fuel-types.creation-modal.input-placeholder'}]">
    </div>
</ng-template>

<ng-template #regionFuelTypeAddModal>
    <div>
        <h3 [i18n]="'decarbonization.fuel-types.region-add.description'"></h3>
        <ng-select class="grow"
                   [items]="filteredFuelTypes"
                   [bindLabel]="'label'"
                   [hideSelected]="true"
                   [(ngModel)]="selectedFuelType"
                   [i18n]="[
                            {target: 'attribute:placeholder', key: 'decarbonization.fuel-types.region-add.dropdown-placeholder'},
                            {target: 'attribute:notFoundText', key: 'decarbonization.fuel-types.region-add.dropdown-empty'}
                           ]">
        </ng-select>
    </div>
</ng-template>

<ng-template #fuelTypeDeletionModal>
    <div class="row">
        <div class="col-xs-12 text-center" [i18n]="'decarbonization.fuel-types.deletion-modal.description'"></div>
    </div>
</ng-template>

<ng-template #fuelTypeRegionRemovalModal>
    <div class="row">
        <div class="col-xs-12 text-center" [i18n]="'decarbonization.fuel-types.remove-region-modal.description'"></div>
    </div>
</ng-template>
